import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService, UserService, CustomerService, AuthenticationService, StorageService, OperationsService } from '../../_services/index';

@Component({
  selector: 'app-ledgerreports',
  templateUrl: './ledgerreports.component.html',
  styleUrls: ['./ledgerreports.component.css']
})
export class LedgerreportsComponent implements OnInit {
  loading = false;
  currentUser: any;
  accounts: any;
  query = {
    'account': {
      'reports_category': '2'
    },
    'customer': {},
    'request': {},
    'start_date': '',
    'end_date': '',
    'start': '0'
  };
  //customers: any;
  requests: any;
  ledgers: any;
  abgls: any;
  FISCAL_DATE_START: any;
  FISCAL_DATE_END: any;
  BAL_GL_ACC_ID: any;
  OTHER_BAL_GL_TYPE = 1;
  result: any;
  start = 0;
  end = false;
  count = 0;
  customers = [];
  records:any;
  constructor(public operationsService: OperationsService, public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  getReportss() {
    this.start = 0;
    this.customers = [];
    this.loading = true;
    this.operationsService.getSubReports(this.currentUser.token, this.FISCAL_DATE_START, this.FISCAL_DATE_END, this.BAL_GL_ACC_ID).subscribe(data => {
      this.loading = false;
      this.result = data;
      this.count = data.records;
      this.getIndAccounts()
    });
  }
  getABGLS() {
    this.operationsService
      .getABGLS(this.currentUser.token)
      .subscribe(res => {
        this.loading = false;
        this.abgls = res.data
      }, () => {
        this.loading = false;

      });
  }
  ngOnInit() {
    //this.initialize();
    this.getABGLS()
  }
  initialize() {
    this.loading = true;
    this.operationsService.initializeLedgerReports(this.currentUser.token, this.query).subscribe(data => {
      this.loading = false;
      this.customers = data.data.customers;
      this.accounts = data.data.accounts;

    });
  }
  getReports() {
    this.loading = true;
    this.operationsService.getLedgerReports(this.currentUser.token, this.query).subscribe(data => {
      this.loading = false;

      this.ledgers = data;
    });
  }
  loadCustomerLoans(event) {
    this.loading = true;
    this.operationsService.loadCustomerLoans(this.currentUser.token, this.query.customer).subscribe(data => {
      this.loading = false;
      this.requests = data.data.requests;
    });
  }
  getIndAccounts() {
    // do {
    //   this.loading = true;
    //   this.operationsService.getIndAccounts(this.currentUser.token, this.FISCAL_DATE_START, this.FISCAL_DATE_END, this.BAL_GL_ACC_ID, this.start, this.count).subscribe(data => {
    //     this.loading = false;
    //     this.end = data.end;
    //     this.start = data.start;

    //   });
    // } while (!this.end)
    
      this.loading = true;
      this.operationsService.getIndAccounts(this.currentUser.token, this.FISCAL_DATE_START, this.FISCAL_DATE_END, this.BAL_GL_ACC_ID, this.start, this.count).subscribe(data => {
        this.loading = false;
        this.end = data.end;
        this.start = data.start;
        this.records = data.records;
        this.records.forEach((officer) => {
          this.customers.push(officer);
        });
      }); 
  }
  getTotal(opening_balance,total_debit,total_credit){
    return parseInt(opening_balance)+parseInt(total_debit)-parseInt(total_credit)
  }
}
